
// You can write more code here

/* START OF COMPILED CODE */

import EntityRelic from "../EntityRelic";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class RelicHelmet extends EntityRelic {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 74, y ?? 47);

    // boots
    const helmet = scene.add.image(0, 0, 'game-all', 'relic-helmet.png');
    helmet.scaleX = 0.5;
    helmet.scaleY = 0.5;
    this.add(helmet);

    this.helmet = helmet;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private helmet: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    this.setSize(this.helmet.displayWidth, this.helmet.displayHeight);

    super.injectMatter(target);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
